import { Button, Card, Typography } from '@customink/pigment-react';
import { useConfigContext } from '@customink/project-service-react-components';
import type { DesignCid } from '@customink/project-service-react-components';
import { useCallback } from 'react';

import shirts from '@/assets/shirts.svg';
import { colorPurple, colorWhite, spacing42 } from '@/utils/designTokens';

export type CatalogIframeOpenHandler = (args: {
  compatibleType?: string;
  designCid?: string;
}) => void;

export default function CatalogCard({
  designCid,
  onClick,
}: {
  designCid: DesignCid | undefined;
  onClick: CatalogIframeOpenHandler;
}) {
  // FIXME: this should probably be a boolean prop passed to this component
  const catalogUrl = useConfigContext().catalogUrl;
  const cardVisibility = catalogUrl ? {} : { visibility: 'hidden' };

  const handleClick = useCallback(() => {
    onClick({ designCid });
  }, [designCid]);

  const imageStyles = {
    height: spacing42,
    width: '116px',
  };

  const cardStyles = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    gap: '12px',
    backgroundColor: colorPurple,
    cursor: 'pointer',
    padding: '2rem 1rem',
    '& .MuiCardContent-root': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& .MuiButtonBase-root.MuiButton-root.MuiButton-outlined': {
      color: colorWhite,
      backgroundColor: colorPurple,
      border: `2px solid ${colorWhite}`,
      fontWeight: 'normal',
      '&:hover': {
        color: colorPurple,
        backgroundColor: colorWhite,
      },
    },
    cardVisibility,
  };
  return (
    <Card onClick={handleClick} size="small" sx={cardStyles}>
      <img alt="shirts" src={shirts} style={imageStyles} />
      <Typography
        color={colorWhite}
        margin="0 -4px 4px"
        variant="uiTextDefault"
      >
        View more items that your group will love
      </Typography>
      <Button size="large" style={{ whiteSpace: 'nowrap' }} variant="secondary">
        Take a look
      </Button>
    </Card>
  );
}
